module.exports = __webpack_public_path__ + "img/podacha_doc.c6fdcfed.svg";